const quickLoginPopup =
() => {
  const loginModalMain = document.getElementById("loginModalMain_edit");
  if (!loginModalMain) return;
  try {
        const loginEmailId = loginModalMain.querySelector("#loginEmailId_edit");
    const loginPassword = loginModalMain.querySelector("#loginPassword_edit");
    const mainSelection = loginModalMain.querySelector(".main-selection");
    const btnTriggerLoginCustomerApi =
      loginModalMain.querySelector("#login-cta-clicked");
    const loginOtpBtn =
      loginModalMain.querySelector("#login-otp");
    const eyeIconViewPassword = loginModalMain.querySelector(
      ".eye-icon-display-password"
    );
    const viewEyeIcon = eyeIconViewPassword.querySelector(".view-eye-icon");
    const hideEyeIcon = eyeIconViewPassword.querySelector(".hide-eye-icon");
    const isV2 = loginModalMain.classList.contains("isV2");
    const locationPath = location.pathname.replace('/pages/latest', '').split('/');
    const country = locationPath[1];
    const lang = locationPath[2];
    const forgotPasswdLink = loginModalMain.querySelector('.forgot_password_link');
    const userEmail = loginModalMain.querySelector(".user-email");
    loginEmailId.value = decodeURIComponent(CookieService.getCookie("User_Email"));
    let emailStore = maskingEmail(decodeURIComponent(CookieService.getCookie("User_Email")));
    const editIcon = loginModalMain.querySelector(".edit-icon");
    const editEmail = loginModalMain.querySelector(".editemail");
    const inputEmailContainer = loginModalMain.querySelector(".inputemailcontainer");
    const quickLoginCheckBox = loginModalMain.querySelector(".checkBox");
    userEmail.innerHTML = emailStore;
    const loginButtonMobile = document.getElementById("wu-mobile-login-button");
    const quickLoginClose = loginModalMain.querySelector(".quickLoginClose");
    const rememberForgot = loginModalMain.querySelector(".remember-forgot-container");
    const editDropdownBtn = loginModalMain.querySelector(".edit-dropdown-btn");
    const closeDropdownBtn = loginModalMain.querySelector(".close-dropdown-btn");
    const dropdownBorders = loginModalMain.querySelector(".dropdown-borders");
    const inputField = loginModalMain.querySelector("#input-field-quickLogin");
    const flagSelector = loginModalMain.querySelector(".flag-selector");
    const globeSelector = loginModalMain.querySelector(".globe-selector");
    const passwordClassError = loginModalMain.querySelector(".passwordClassError");
    const dropdownText = loginModalMain.querySelector(".dropdown-text");
    const loginEmailIdError = loginModalMain.querySelector(".loginEmailId_error");
    const quickLoginContainer = loginModalMain.querySelector(".quickLoginContainer");
    const dropdownInfoText = loginModalMain.querySelector(".dropdown-info-text");
    const passwordWrong = loginModalMain.querySelector(".loginPassword-error");
    const dropdownHeading = loginModalMain.querySelector(".dropdown-heading");
    let isPasswordDirty = false;
    let isEditable = false;

    const isMasked = (email) => {
      return email.includes("*");
    };

    const checkEmail = () => {
      if(CookieService.getCookie("User_Email")){
      const userEmailCookie = decodeURIComponent(CookieService.getCookie("User_Email"));
      return userEmailCookie.trim() !== "";
    } else {
      return false;
    }
  };

  function closeModal(){
      window.sessionStorage.removeItem("popUpName");
      hideLogin();
      inactivityTime(17, showLogin);
      isEditable = false;
      passwordWrong.classList.add("d-none");
      loginEmailIdError.classList.add("d-none");
      inputEmailContainer.classList.remove("wu-input--error");
      loginPassword.value="";
      passwordClassError.classList.remove("wu-input--error");
      inputEmailContainer?.classList.add("d-none");
      toggleClass(editEmail,"d-none","d-flex");
      rememberForgot?.classList.remove("pad-12-bm");
      quickLoginCheckBox?.classList.add("invisible");
      resetPasswordState();
      isPasswordDirty = false;
  };

    function  showLogin() {
      if (checkEmail()) {
        const isLoggedIn = window.sessionStorage.getItem('AccountNumber');
        const userIdentity = CookieService.getCookie('userIdentity'); //registeredCustomer,existingCustomer, newCustomer
        const isExistingOrRegisteredUser = userIdentity === 'existingCustomer' || userIdentity === 'registeredCustomer';
        if(!isLoggedIn && isExistingOrRegisteredUser) {
          mainSelection.classList.add("d-L-block");
          setPopupPosition();
          if (typeof window.logPopUpEvent !== "undefined") {
            if(window.sessionStorage.getItem("popUpName") !== "open-quick-login") {
              window.sessionStorage.setItem("popUpName", "open-quick-login");
            }
            window.sessionStorage.setItem("userSelectedCountry", country?.toLowerCase());
            window.logPopUpEvent();
          }

          if (sessionStorage.getItem('currentFlow')) {
            sessionStorage.removeItem("currentFlow");
          }
          if (sessionStorage.getItem('loginType')) {
            sessionStorage.removeItem("loginType");
          }
        }
      }
    };

    inactivityTime(17, showLogin);
    function hideLogin() {
      mainSelection.classList.remove("d-L-block");
    };


    loginButtonMobile.addEventListener("mouseenter", (e) => {
        showLogin();
    });

    function setPopupPosition() {
      const modalTop = loginButtonMobile.offsetTop + loginButtonMobile.offsetHeight + 10;
      const modalLeft = loginButtonMobile.offsetLeft - quickLoginContainer.clientWidth + loginButtonMobile.offsetWidth;
      quickLoginContainer.style.top = modalTop + 'px';
      quickLoginContainer.style.left = modalLeft + 'px';
    }

    dropdownInfoText.addEventListener("click", (e)=>{
      e.stopPropagation();
    });
    dropdownHeading.addEventListener("click",(e)=>{ e.stopPropagation()});
    globeSelector.addEventListener("click",(e)=>{ e.stopPropagation()});
    flagSelector.addEventListener("click",(e)=>{ e.stopPropagation()});


    inputField.addEventListener("keyup", (e)=>{
        const quickCountryList = loginModalMain.querySelector(".dropDn_country");
        if(quickCountryList.classList.contains("d-none")){
          dropdownInfoText.classList.add("d-none");
          inputField.classList.add("bdr-radius-bm");
          inputField.classList.add("bdr-radius-tp");
          inputField.classList.add("bdr-thin-horz");
        }else{
          dropdownInfoText.classList.remove("d-none")
          inputField.classList.remove("bdr-radius-bm");
          inputField.classList.remove("bdr-radius-tp");
          inputField.classList.remove("bdr-thin-horz");
        }
    });

    quickLoginClose.addEventListener("click",() => {
      closeModal();
    });
    
    closeDropdownBtn.addEventListener("click",() => {
      loginModalMain.click();

    });
    loginEmailId.addEventListener('blur',()=> {
      const emailIdValue = loginEmailId.value;
      if(!emailIdValue.match(mailformat)) {
        loginEmailIdError.classList.remove("d-none");
        inputEmailContainer.classList.add("wu-input--error");
      } else {
        loginEmailIdError.classList.add("d-none");
        inputEmailContainer.classList.remove("wu-input--error");
      }
    });

    loginEmailId.addEventListener('focus',()=> {
      const emailIdValue = loginEmailId.value;
      if(!emailIdValue.match(mailformat)) {
        loginEmailIdError.classList.add("d-none");
        inputEmailContainer.classList.remove("wu-input--error");
      }
    });

    loginPassword.addEventListener('blur',()=> {
      const passwd = loginPassword.value;
      if(!passwd) {
         passwordWrong.classList.remove("d-none");
         passwordClassError.classList.add("wu-input--error");
      }  else {
        passwordWrong.classList.add("d-none");
        passwordClassError.classList.remove("wu-input--error");
      }
    });

    loginPassword.addEventListener('keyup',()=> {
       const passwd = loginPassword.value;
       isPasswordDirty = true;
        if (!passwd) {
          // Add error
          passwordClassError.classList.add("wu-input--error");
        } else {
          // remove error
          passwordWrong.classList.add("d-none");
          passwordClassError.classList.remove("wu-input--error");
        }
    });

    function resetPasswordState() {
      loginPassword?.setAttribute("type", "password");
      hideEyeIcon.classList.add("d-inline");
      hideEyeIcon.classList.remove("d-none");
      viewEyeIcon.classList.add("d-none");
      viewEyeIcon.classList.remove("d-inline");
    }

    loginPassword.addEventListener('focus',()=> {
      const passwd = loginPassword.value;
      if (!passwd && isPasswordDirty) {
        // Add error
        passwordClassError.classList.add("wu-input--error");
        passwordWrong.classList.add("d-none");
      } else {
        // remove error
        passwordWrong.classList.add("d-none");
        passwordClassError.classList.remove("wu-input--error");
      }
         });

      window.addEventListener("resize",setPopupPosition);

      window.addEventListener('click', function(e) {
        if (!loginModalMain.contains(e.target)) {
          closeModal();
        }
        if (e.target.classList && e.target.classList.value && e.target.classList.value.indexOf('dropdown-heading') !== -1){
          return
        }
        const  dropdownItems = loginModalMain.querySelectorAll(".wuds-dropdown__items") ;
        if (e.target.classList && e.target.classList.value && e.target.classList.value.indexOf('quick-country-dropdown') === -1) {
          // Close"
          dropdownBorders.classList.remove("bdr-rt-color-black", "bdr-thin-rt","bdr-lt-color-black", "bdr-thin-lt", "bdr-thin-tp","bdr-radius-all", "bdr-radius-tp");
          editDropdownBtn.classList.remove('d-none');
          closeDropdownBtn.classList.add('d-none');
          inputField.classList.remove("bk-transparent");
          globeSelector.classList.add("d-none");
          flagSelector.classList.remove("d-none");
          dropdownText.classList.add("d-none");
          dropdownItems?.forEach(item =>{
          item.removeEventListener("mouseover",()=>{})
          item.removeEventListener("mouseout",()=>{})
          inputField.value = "";
          inputField.dispatchEvent(new Event('input', {bubbles: true}));
        });
        } else {
            // Open
            dropdownBorders.classList.add("bdr-thin-rt","bdr-rt-color-black", "bdr-thin-lt","bdr-lt-color-black", "bdr-thin-tp","bdr-radius-all", "bdr-radius-tp");
            editDropdownBtn.classList.add('d-none');
            closeDropdownBtn.classList.remove('d-none');
            inputField.classList.add("bk-transparent");
            globeSelector.classList.remove("d-none");
            flagSelector.classList.add("d-none");
            dropdownText.classList.remove("d-none");
            dropdownItems.forEach(item =>{
            item.addEventListener("mouseover", (e)=>{
              item.classList.add("bk-info-lighter");
            });
            item.addEventListener("mouseout", (e)=>{
              item.classList.remove("bk-info-lighter");
              const flagCountryCode =item.dataset?.flagSelectValue;
              if (country == flagCountryCode){
                item.classList.add("bk-info-lighter");
              }
            });

            const flagCountryCode =item.dataset?.flagSelectValue;
            if (country == flagCountryCode){
              item.classList.add("bk-info-lighter");
            }});
          }
           });

    editIcon.addEventListener("click", (e) => {
      e.stopPropagation();
      const rememberEmail = loginModalMain.querySelector(".remember");
      rememberEmail.checked = true;
      isEditable = true;
      if(CookieService.getCookie("User_Email")){
      loginEmailId.value = decodeURIComponent(CookieService.getCookie("User_Email"));
      inputEmailContainer.classList.remove("d-none");
      toggleClass(editEmail,"d-flex","d-none");
      rememberForgot.classList.add("pad-12-bm")
      quickLoginCheckBox.classList.remove("invisible");

  }});

    eyeIconViewPassword?.addEventListener("click", (event) => {
      const typeOfErrorInput = loginPassword.getAttribute("type");
      if (typeOfErrorInput === "text") {
        loginPassword?.setAttribute("type", "password");
        toggleClass(viewEyeIcon, "d-inline", "d-none");
        toggleClass(hideEyeIcon, "d-none", "d-inline");
      } else {
        loginPassword?.setAttribute("type", "text");
        toggleClass(viewEyeIcon, "d-none", "d-inline");
        toggleClass(hideEyeIcon, "d-inline", "d-none");
      }
    });

    const onKeyPressEventOfInputFields = (event) => {
      let elementId = event.currentTarget.id;
      let elementObject = document.getElementById(elementId);
      showHideValidationMessage(elementObject,"hide");
    };

    const triggerEmailValidation = (emailAddressEL) => {
      if (emailAddressEL) {
        showHideValidationMessage(emailAddressEL,"hide");
        let emailAddress = emailAddressEL.value;
        if (emailAddress !== undefined) {
          if (isMasked(emailAddress)) {
            loginEmailIdError.classList.add("d-none");
            inputEmailContainer.classList.remove("wu-input--error");
            return true;
          } else if  (!emailAddress) {
              showHideValidationMessage(emailAddressEL,"show");
              loginEmailIdError.classList.remove("d-none");
              inputEmailContainer.classList.add("wu-input--error");
              return false;
            } else if (!emailAddress.match(mailformat)) {
              showHideValidationMessage(emailAddressEL,"show");
              loginEmailIdError.classList.remove("d-none");
              inputEmailContainer.classList.add("wu-input--error");
              return false;
            }  else {
              loginEmailIdError.classList.add("d-none");
              inputEmailContainer.classList.remove("wu-input--error");
              return true;
            }
          }
        }
    };


    forgotPasswdLink.addEventListener("click",()=>{
      if(isFeatureEnabledViaSessionStorage("isResetWithOTPV2Enabled")) {
        sessionStorage.setItem("loginType", 'reset-with-code');
      } else {
        sessionStorage.setItem("loginType", 'reset-with-link');
      }
      sessionStorage.setItem("currentFlow", 'reset');
      location.href = `/${country}/${lang}/web/user/forgot-password`
    });

    const triggerPasswordValidation = (passwordEL) => {
      if (passwordEL) {
        showHideValidationMessage(passwordEL,"hide");
        eyeIconView(true, isV2, eyeIconViewPassword,{top: "40%"});
        let passwd = passwordEL.value;
        if (passwd !== undefined) {
          if (!passwd) {
            showHideValidationMessage(passwordEL, "show");
            eyeIconView(false, isV2, eyeIconViewPassword,{top: "40%"});
            passwordEL.focus();
            passwordWrong.classList.remove("d-none");
            passwordClassError.classList.add("wu-input--error");
            return false;
          } else {
            passwordWrong.classList.add("d-none");
            passwordClassError.classList.remove("wu-input--error");
            return true;
          }
        }
      }
    };
    if(loginEmailId.value) {
      loginEmailId.setAttribute("value", decodeURIComponent(loginEmailId.value))
    };
    if(loginPassword.value)
      loginPassword.setAttribute("value", loginPassword.value);
    loginEmailId.addEventListener("keypress", onKeyPressEventOfInputFields);
    [loginEmailId, loginPassword].forEach((el) => {
      el.addEventListener("input", (event) => {
        event.target.setAttribute("value", event.target.value);
      });
    });
    btnTriggerLoginCustomerApi &&
      btnTriggerLoginCustomerApi.addEventListener("click", function () {
        sessionStorage.setItem("currentFlow", 'login');
        sessionStorage.setItem("loginType", 'login-with-password');
        const rememberEmail = loginModalMain.querySelector(".remember");
        const isChecked = rememberEmail.checked;

        const userData = {};
        loginEmailId.value = loginEmailId.value?.trim();
        userData.rememberMeChecked = isChecked;
        userData.emailId = loginEmailId.value;
        userData.password = loginPassword.value;
        const isEmailValid = isEditable ? triggerEmailValidation(loginEmailId) : true;
        const isPasswordValid = triggerPasswordValidation(loginPassword);
        if (isEmailValid && isPasswordValid) {
          closeModal();
          onCustomerLogin(userData);
        }
      });

      loginOtpBtn &&
      loginOtpBtn.addEventListener("click", function () {
        sessionStorage.setItem("currentFlow", 'login');
        sessionStorage.setItem("loginType", 'login-with-code');
        location.href = `/${country}/${lang}/web/user/otp-login`;
      });
  } catch (e) {
    // Error handled silently for security
  }
}



function quickLoginViaCode() {
  const country = (getCookieValueByKeyName('WUCountryCookie_') || '').toUpperCase();
  return QUICK_LOGIN_VIA_CODE_COUNTRIES.indexOf(country) > -1;
}

function otpLoginVisibility() {
  const blockElement = document.querySelector(".login-with-code");
  blockElement?.classList.remove('d-none');
}

function loginWithCode() {
  if(isFeatureEnabledViaSessionStorage("isOtpLoginEnabled")) {
    const {country, lang} = getCountryAndLanguage();
    const { sessionId, clientIp } = typeof getSessionAndClientIpFromCookies === 'function' ? getSessionAndClientIpFromCookies() : { sessionId: null, clientIp: null };
    if(CookieService.getCookie(DEVICE_VERIFICATION_COOKIE)) {
      otpLoginVisibility();
    } else if(sessionId && clientIp) {
      otpLoginVisibility();
    } else {
      try{
        createSessionMethod(country, lang, window.location.host).then((response) => {
          setCookieOnCreateSessionResponse(response);
          if(CookieService.getCookie(DEVICE_VERIFICATION_COOKIE)) {
            otpLoginVisibility();
          }
        }).catch((error) => {
            console.error(error);
        });
      } catch (e) {
        console.error('error from create session : ', e)
      }
    }
  }
}

 let quickLoginFlag = CookieService.getCookie('rodeoR4Experience')? CookieService.getCookie('rodeoR4Experience'):"false";
if(!quickLoginFlag) {
  if(quickLoginViaCode()) {
    quickLoginPopup();
    document.addEventListener('optimizelyOtpQuickLogin', loginWithCode);
  } else {
    ["evergageQuickLogin", "optimizelyQuickLogin"].forEach(function(e) { 
      document.addEventListener(e, () => {
          sessionStorage.getItem("isQuickLoginEnabled") && quickLoginPopup();
      }); 
    });
    document.addEventListener('optimizelyOtpQuickLogin', loginWithCode);
  }
}